import catalogContexts from "@utils/constants/catalogContexts";

export default function forceUserSizeFiltersOnUiState(
  uiState,
  mainIndex,
  userSizeFilters,
  context,
  stockForC1,
  catalogVersion,
) {
  if (context === catalogContexts.userlist) return uiState;
  if (!userSizeFilters) return uiState;
  if (
    uiState[mainIndex].refinementList.sizes?.length > 0 ||
    uiState[mainIndex].refinementList.available_sizes?.length > 0 ||
    uiState[mainIndex].refinementList.available_sizes_for_c1?.length > 0
  )
    return uiState;

  const newUiState = { ...uiState };
  const userSizeFiltersCopy = [...userSizeFilters];

  if (
    catalogVersion === 1 ||
    newUiState[mainIndex].refinementList.in_stock?.includes("false") ||
    newUiState[mainIndex].refinementList.in_stock_for_c1?.includes("false")
  ) {
    newUiState[mainIndex].refinementList.sizes = userSizeFiltersCopy;
  } else if (stockForC1) {
    newUiState[mainIndex].refinementList.available_sizes_for_c1 = userSizeFiltersCopy;
  } else {
    newUiState[mainIndex].refinementList.available_sizes = userSizeFiltersCopy;
  }

  return newUiState;
}
